import { post, get } from './request'

export default {
  createTeam: (payload, success, failure) => post('/api/team', payload, success, failure),
  updateMemberPermissions: (payload, success, failure) => post(`/api/team/${payload.team}/member-permissions`, payload, success, failure),
  removeTeamMember: (payload, success, failure) => post(`/api/team-member/${payload}/remove`, {}, success, failure),
  loadTeam: (payload, success, failure) => get(`/api/team/${payload}`, success, failure),
}
